import axios from 'axios';

function getRequest(path = '') {
  let url = process.env.QUIZ_URL !== 'undefined' ? process.env.QUIZ_URL : 'https://quiz.builderall.com';
  const token = 'eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.zdCmlQ3cJJqh-OhXWsbXtv47lWvFRi2V7YiBJOqSKQo'

  return axios.create({
    baseURL: url + '/api/cheetah/',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'x-integration-secret': token
    }
  });
}

export const getQuiz = (email) => getRequest().get(`user-quizzes/${email}`)



// WEBPACK FOOTER //
// ./src/js/services/integrations-internas/quiz.js